import { Row } from '../grid';
export default Row;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/row/index.js
// module id = 281
// module chunks = 0